import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import { replacementTransportPlanColumns } from "./lib/constants/replacementTransportPlanColumns";
import { fetchReplacementTransportPlans } from "../../../../lib/api/resources/replacementTransports";
import { Table } from "@/components/v2";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "@rumbledirect/ui";

export const ReplacementTransportPlansList = () => {
  const [page, setPage] = useState(1);

  const replacementTransportPlansQuery = useQuery({
    queryKey: ["replacementTransportPlans", page],
    queryFn: () => fetchReplacementTransportPlans({ page }),
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/replacement-transport/plans/create">
          <Button icon={<PlusOutlined />}>
            Nieuwe vervangend vervoer plan
          </Button>
        </Link>
      </Space>
      <Table
        columns={replacementTransportPlanColumns}
        dataSource={replacementTransportPlansQuery.data?.member}
        loading={replacementTransportPlansQuery.isLoading}
        pagination={{
          pageSize: 15,
          total: replacementTransportPlansQuery.data?.totalItems,
          showSizeChanger: false,
          onChange: (page) => setPage(page),
        }}
      />
    </div>
  );
};
